// Import jQuery
import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

// Import bootstrap plugins.
import '../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/affix';
import '../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/button';
import '../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse';
import '../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/scrollspy';
import '../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/tab';
import '../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition';

import Swiper from 'swiper';


// WEBPACK FOOTER //
// ./js/vendors.js